import axios from 'axios'
import { getProviderById, getCurrentProvider } from '@/config/ai-providers'
import { extractApiErrorMessage } from './extract-api-error-message'

const clientCache = {}

function safeStringify(obj, maxLen) {
  try {
    var s = typeof obj === 'string' ? obj : JSON.stringify(obj, null, 2)
    var limit = typeof maxLen === 'number' ? maxLen : 2000
    if (s && s.length > limit) {
      return s.slice(0, limit) + '\n... [truncated] len=' + s.length
    }
    return s
  } catch (e) {
    return '[unserializable]'
  }
}

/**
 * 获取指定平台的 AI 请求 client（独立 baseURL + Authorization）
 * @param {string} [providerId] 平台 id，不传则使用当前配置的默认平台
 * @returns {import('axios').AxiosInstance}
 */
export function getAiClient(providerId) {
  const provider = providerId ? getProviderById(providerId) : getCurrentProvider()
  if (!provider || !provider.baseURL) {
    throw new Error('AI provider not configured: ' + (providerId || 'current'))
  }
  if (!clientCache[provider.id]) {
    clientCache[provider.id] = axios.create({
      baseURL: provider.baseURL.replace(/\/$/, ''),
      timeout: 120000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    clientCache[provider.id].interceptors.request.use(function (config) {
      if (typeof provider.getHeaders === 'function') {
        var headers = provider.getHeaders()
        if (headers && typeof headers === 'object') {
          Object.keys(headers).forEach(function (k) {
            if (headers[k]) config.headers[k] = headers[k]
          })
        }
      } else if (typeof provider.getAuthorization === 'function') {
        var auth = provider.getAuthorization()
        if (auth) config.headers.Authorization = auth
      }
      var fullUrl = (config.baseURL || '') + (config.url || '')
      var method = (config.method || 'get').toUpperCase()
      console.log('[AI Request]', method, fullUrl)
      console.log('[AI Request] headers:', JSON.stringify(config.headers, null, 2))
      if (config.data !== undefined) {
        console.log('[AI Request] body:', safeStringify(config.data, 2000))
      }
      if (config.params && Object.keys(config.params).length > 0) {
        console.log('[AI Request] params:', config.params)
      }
      return config
    }, function (err) { return Promise.reject(err) })
    clientCache[provider.id].interceptors.response.use(
      function (res) {
        console.log('[AI Response]', (res.config && res.config.method) ? res.config.method.toUpperCase() : '', res.config && res.config.url, res.data != null ? safeStringify(res.data, 2000) : res.data)
        return res.data
      },
      function (err) {
        const msg = extractApiErrorMessage(err.response && err.response.data) || err.message || '请求失败'
        return Promise.reject(new Error(msg))
      }
    )
  }
  return clientCache[provider.id]
}
